
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 513 182"}},[_c('path',{attrs:{"fill":"#A4C4C5","fill-rule":"evenodd","d":"M41.774 0l102.689 3.601c5.622 15.06 11.096 26.777 16.421 35.15 4.495 7.068 13.75 18.512 27.768 34.332C248.129 106.72 419.242-30.607 513 167.505c0 0-108.3 13.163-242.825 14.346C59.675 183.7-71.655 170.835 41.775 0z"}})])
      }
    
      }
    